// src/components/organisms/ViewAllChallengesSection.js

import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import ChallengeCard from "../molecules/ChallengeCard";

const ViewAllChallengesSection = ({ header, challenges, theme }) => {
  return (
    <Box
      sx={{
        borderRadius: "25px",
        paddingBottom: 0,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          pt: 4,
          pr: 0,
          pb: 4,
          pl: 0,
          mt: 4,
          mr: 4,
          mb: 8,
          ml: 4,
          borderBottom: `1px solid ${theme.colors.darkGray}`,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontFamily: "basic-sans",
          }}
        >
          {header}
        </Typography>
      </Box>

      <Box
        sx={{
          pt: 4,
          pr: 0,
          pb: 4,
          pl: 0,
          mt: 4,
          mr: 4,
          mb: 8,
          ml: 4,
        }}
      >
        {/* Grid of Challenge Cards */}
        <Grid container spacing={4}>
          {challenges.map((challenge) => (
            <Grid item xs={12} sm={6} md={4} key={challenge.id}>
              {/* Challenge Card */}
              <ChallengeCard challenge={challenge} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default ViewAllChallengesSection;
